import Vue from 'vue'

export default Vue.directive('random-size', {
  bind (el, binding) {
    const circleSize = Math.floor(Math.random() * (313 - 140) + 140)
    el.setAttribute('style', `width:${circleSize}px; height:${circleSize}px`)
  }
})



// WEBPACK FOOTER //
// ./src/components/custom/custom-home-testimonials/custom-home-testimonials.directive.js